export default function mobileMenu() {
  const nav = document.getElementById("mobile-nav");
  if (!nav) {
    return;
  }

  const toggles = document.querySelectorAll(".js-mobile-menu-toggle");
  if (toggles.length === 0) {
    return;
  }

  const closers = nav.querySelectorAll("[data-mobile-menu-close]");
  const innerTriggers = nav.querySelectorAll("[data-view-trigger]");

  const setToggleState = (isOpen) => {
    toggles.forEach((toggle) => {
      toggle.classList.toggle("is-open", isOpen);
      toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  };

  const open = () => {
    nav.classList.add("is-open");
    nav.setAttribute("aria-hidden", "false");
    setToggleState(true);
  };

  const close = () => {
    nav.classList.remove("is-open");
    nav.setAttribute("aria-hidden", "true");
    setToggleState(false);
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      if (nav.classList.contains("is-open")) {
        close();
      } else {
        open();
      }
    });
  });

  closers.forEach((closer) => {
    closer.addEventListener("click", close);
  });

  // Close automatically after picking a view so the content is revealed.
  innerTriggers.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.disabled) {
        return;
      }
      close();
    });
  });

  // Close the drawer if the viewport expands past the mobile breakpoint.
  const mediaQuery = window.matchMedia("(min-width: 1024px)");
  const handleBreakpoint = (event) => {
    if (event.matches && nav.classList.contains("is-open")) {
      close();
    }
  };
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", handleBreakpoint);
  } else if (typeof mediaQuery.addListener === "function") {
    mediaQuery.addListener(handleBreakpoint);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && nav.classList.contains("is-open")) {
      close();
    }
  });
}
